import React from 'react';
import { RandomCssDemo } from './RandomCssDemo';
import { makeDivs } from './utils';

const ROTATING_RECTANGLES_HTML = makeDivs(36, 'tile');

export function RotatingRectanglesExample() {
  return (
    <RandomCssDemo
      title="Randomly Rotating Rectangles"
      htmlBody={ROTATING_RECTANGLES_HTML}
      scaffoldCss={`
        * { box-sizing: border-box; }
        html { overflow: hidden; }
        body {
          position: absolute;
          margin: 0;
          inset: 0;
          background: #e9e0cb;
          display: grid;
          grid-template-columns: repeat(6, 1fr);
          grid-template-rows: repeat(6, 1fr);
          transform-style: preserve-3d;
          transform: perspective(500px);
        }
        .tile {
          align-self: center;
          justify-self: center;
          background: #000a;
      }
      `}
      cssCodeInit={`.tile {
  width: random(25%, 75%);
  height: random(25%, 75%);
  border-radius: random(10px, 20px);
  transform-style: preserve-3d;
  --rotx: random(-25deg, 25deg);
  animation: rotate random(5s, 10s) linear infinite;
  animation-delay: random(-5s, 0s);
}

@keyframes rotate {
  from {
    transform: perspective(500px)rotateY(0deg) rotateZ(-30deg);
  }
  to {
    transform: perspective(500px) rotateY(360deg) rotateZ(330deg);
  }
}`}
    />
  );
}
